import { render, staticRenderFns } from "./ShortAnswer_bank.vue?vue&type=template&id=79e38836"
import script from "./ShortAnswer_bank.vue?vue&type=script&lang=js"
export * from "./ShortAnswer_bank.vue?vue&type=script&lang=js"
import style0 from "./ShortAnswer_bank.vue?vue&type=style&index=0&id=79e38836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports